// utils/firebaseConfig.js

import { initializeApp }   from 'firebase/app';
import { getFirestore }    from 'firebase/firestore';
import { getAuth }         from 'firebase/auth';
import { getStorage }      from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

/* ─────────────  YOUR PROJECT CONFIG  ───────────── */
const firebaseConfig = {
  apiKey:            'AIzaSyA15RDyEhIrrpyqukoH9A3RQuJqcE8qZlQ',
  authDomain:        'hyrovault.firebaseapp.com',
  projectId:         'hyrovault',
  storageBucket:     'hyrovault.appspot.com',
  messagingSenderId: '123683151448',
  appId:             '1:123683151448:web:8bb4737e2d8f5f9e7ef42d',
  measurementId:     'G-2PQ0ERQH2G',
};

/* ─────────────  CORE INITIALISATION  ───────────── */
const app      = initializeApp(firebaseConfig);
const db       = getFirestore(app);
const auth     = getAuth(app);
const storage  = getStorage(app);

/* ─────────────  OPTIONAL ANALYTICS  ───────────── */
let analytics = null;             // always export *something*
isSupported()
  .then((ok) => {
    if (ok) {
      try {
        analytics = getAnalytics(app);
      } catch (err) {
        // Installations outage, tracker-blocker, etc.
        console.warn('Analytics not initialised:', err);
      }
    }
  })
  .catch(() => {});               // swallow network errors

/* ─────────────  NAMED EXPORTS  ───────────── */
export { app, db, auth, storage, analytics };
